<script>
// import { isApp } from '@/api/app'
// import AppDetail from './device/app'
import WebDetail from './device/web'

export default {
  render: function (createElement) {
    let element = WebDetail
    // 区分App还是web
    // if(isApp()){
      // element = AppDetail
    // }
    return createElement(element)
  },
  props: {
  }
}
</script>